module.exports = __webpack_public_path__ + "static/media/postgresql.d7c985e7.svg";